// extracted by mini-css-extract-plugin
export var cell = "_5f-4";
export var headerCell = "_5f-2";
export var rowHeader = "_5f-3";
export var table = "_5f-1";
export var tableContainer = "_5f-0";